import React, { useEffect } from "react";
import "../css/about.scss";
import { Link } from "react-router-dom";
import { STORE } from "../config/store";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="about">
      <div className="about-container">
        <nav className="breadcrumb" aria-label="Breadcrumb"><Link to="/">HOME</Link> / ABOUT {STORE.brand.toUpperCase()}</nav>
        <section className="about-intro">
          <h1 className="main-title">About Us</h1>
          <h2 className="sub-header">Useful can still feel special.</h2>
          <p className="intro-text">{STORE.brand} is an online collection of paper goods, home pieces, accessories, play items and personal-care essentials, operated from {STORE.operatingRegion}.</p>
          <div className="about-image-large"><img src="/main/a1.jpg" alt="A considered arrangement of paper, ceramic and textile goods" /></div>
          <p>We look for objects with a clear job and a distinct point of view: a card that leaves room for real words, a bag with sensible proportions, a mug that feels balanced, or a puzzle that rewards a slower hour.</p>
          <p>The collection stays deliberately varied but the standard is consistent. Product pages explain material, measurement, colour, care and likely risks so that choosing an item does not depend on guesswork.</p>
        </section>

        <section className="about-values">
          <h2 className="section-header">WHAT GUIDES THE COLLECTION</h2>
          <p>Good retail information should be as useful as the object itself. Our catalogue is organised around three practical ideas.</p>
          <div className="core-values-summary">
            <h3>{STORE.brand.toUpperCase()} PRINCIPLES</h3>
            <ul><li>CLEAR PRODUCT DETAILS</li><li>PURPOSEFUL VARIETY</li><li>CARE FOR LONGER USE</li></ul>
          </div>
          <div className="value-detail">
            <h3>CLEAR PRODUCT DETAILS</h3>
            <p>Each listing pairs more than a styled image with the facts needed to make a decision. Size, material, colour, intended use, care and precautions sit together on the product page. Where a screen or handmade surface may vary, we say so.</p>
          </div>
          <div className="value-detail">
            <h3>PURPOSEFUL VARIETY</h3>
            <p>The shop moves between paper, textiles, ceramics, jewellery, body care and play because daily life does too. The aim is not an endless catalogue; it is a compact set of distinct options without repeating the same image or item under a different name.</p>
          </div>
          <div className="value-detail">
            <h3>CARE FOR LONGER USE</h3>
            <p>Care notes are specific to the object: keep paper dry, inspect ceramic for chips, protect plated jewellery from moisture, patch test cosmetics, and supervise children with small parts or modelling materials. Safe, informed use matters after checkout as much as before it.</p>
          </div>
        </section>

        <section className="about-founder">
          <h2 className="section-header">HOW WE WORK</h2>
          <div className="founder-image"><img src="/main/a2.jpg" alt="Hands reviewing paper, fabric and ceramic material samples" /></div>
          <p>New listings are reviewed against the existing range so their role, material and imagery remain distinct. Descriptions are written for the item shown rather than borrowed from another retailer.</p>
          <p>Questions about an order, a material or an accessibility need go to <a href={`mailto:${STORE.supportEmail}`}>{STORE.supportEmail}</a>. That email is the service channel published by this website.</p>
        </section>
      </div>
    </main>
  );
}

export default About;
